import { onMounted, onBeforeUnmount } from 'vue';

export function useClickAway(targetRef, handler, eventType = 'mousedown') {
  const handleClick = (event) => {
    const el = targetRef.value;
    if (event.target.closest('UL')?.classList.contains('ignore-click-away'))
      return;
    if (!el || el.contains(event.target)) return;
    handler(event);
  };

  onMounted(() => {
    document.addEventListener(eventType, handleClick);
  });

  onBeforeUnmount(() => {
    document.removeEventListener(eventType, handleClick);
  });
}
